module.exports = __webpack_public_path__ + "static/img/晚班組長-蔣文財.c7aa820.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/晚班組長-蔣文財.png
// module id = 9cNc
// module chunks = 1